import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class FormsService {

	// private _url3: string = "/get-forms"
	// private _url2: string = "https://delta-ctapi.webproductionlabs.com/api/get-registratura-form-test"
	// private _url: string = 'http://alpha-ddru-back.webproductionlabs.com'

	private basePath = environment.basePath

	private formListUrl = environment.routes.ddru.registratura.formList
	private renderFormUrl = environment.routes.ddru.registratura.renderForm
	private storeFormUrl = environment.routes.ddru.registratura.storeForm
	private uploadFileUrl = environment.routes.ddru.registratura.uploadFile

	private verificareAutoUrl = environment.routes.ddru.ridicari_auto.verificariAuto

	private checkPaymentReferenceRidicariUrl = environment.routes.ddru.ridicari_auto.checkPaymentReference
	private processPaymentLinkRidicariUrl = environment.routes.ddru.ridicari_auto.processPaymentLink
	
	private checkPaymentReferenceBlocariUrl = environment.routes.ddru.blocari_auto.checkPaymentReference
	private processPaymentLinkBlocariUrl = environment.routes.ddru.blocari_auto.processPaymentLink

	private checkPaymentReferenceUrl = environment.routes.dmu.platiOnline.verificarePlata

	private tsduInterogareReferintaUrl = environment.routes.dmu.tsdu.interogareReferinta

	constructor(private http: HttpClient) { }


	private httpOptions = {
		headers: new HttpHeaders({
			'Access-Control-Allow-Origin': '*',
		})
	};

	// getForms(categorie: any){
	//   let params = new HttpParams();
	//   params = params.append('categorie', categorie);
	//   return this.http.get(this._url + '/get-forms-list/', {params});
	// }

	// renderForm(form: any, persoana: any, categorie: any){
	//   let params = new HttpParams();
	//   params = params.append('form', form);
	//   params = params.append('tip_persoana', persoana);
	//   params = params.append('categorie', categorie);
	//   return this.http.get(this._url + '/render-form/', {params});
	// }


	getForms(categorie: any) {
		let params = new HttpParams();
		params = params.append('categorie', categorie);
		return this.http.get<{ data: any }>(this.basePath + this.formListUrl, { params })
			.toPromise()
			.then(
				res => res,
				err => err.error
			)
			.catch(e => e.error);
	}

	renderForm(section: any, persoana: any, categorie: any) {
		let params = new HttpParams();
		params = params.append('section', section);
		params = params.append('tip_persoana', persoana);
		params = params.append('categorie', categorie);
		return this.http.get<{ data: any }>(this.basePath + this.renderFormUrl, { params })
			.toPromise()
			.then(
				res => res,
				err => err.error
			)
			.catch(e => e.error);
	}

	storeRegistratura(data: any) {
		return this.http.post<{ data: any }>(this.basePath + this.storeFormUrl, data)
			.toPromise()
			.then(
				res => res,
				err => err.error
			)
			.catch(e => e.error);
	}

	fileUpload(fileData: FormData){
		return this.http.post<{ fileData: any }>(this.basePath + this.uploadFileUrl, fileData)
		.toPromise()
		.then(
			res => res,
			err => err.error
		)
		.catch(e => e.error);
	}

	verificareAuto(data: any) {
		return this.http.post<{ data: any }>(this.basePath + this.verificareAutoUrl, data)
			.toPromise()
			.then(
				res => res,
				err => err.error
			)
			.catch(e => e.error);
	}

	checkPaymentReferenceRidicari(data: any) {
		let params = new HttpParams();
		params = params.append('numar_auto', data.numar_auto);
		return this.http.get<{ data: any }>(this.basePath + this.checkPaymentReferenceRidicariUrl, { params })
			.toPromise()
			.then(
				res => res,
				err => err.error
			)
			.catch(e => e.error);
	}

	processPaymentLinkRidicari(data: any) {
		let params = new HttpParams();
		params = params.append('numar_auto', data.numar_auto);
		return this.http.get<{ data: any }>(this.basePath + this.processPaymentLinkRidicariUrl, { params })
			.toPromise()
			.then(
				res => res,
				err => err.error
			)
			.catch(e => e.error);
	}

	checkPaymentReferenceBlocari(data: any) {
		let params = new HttpParams();
		params = params.append('numar_auto', data.numar_auto);
		return this.http.get<{ data: any }>(this.basePath + this.checkPaymentReferenceBlocariUrl, { params })
			.toPromise()
			.then(
				res => res,
				err => err.error
			)
			.catch(e => e.error);
	}

	processPaymentLinkBlocari(data: any) {
		let params = new HttpParams();
		params = params.append('numar_auto', data.numar_auto);
		return this.http.get<{ data: any }>(this.basePath + this.processPaymentLinkBlocariUrl, { params })
			.toPromise()
			.then(
				res => res,
				err => err.error
			)
			.catch(e => e.error);
	}

	checkPaymentReference(data: any, processLink: boolean = false) {
		let params = new HttpParams();
		params = params.append('referenceNumber', data.reference);
		return this.http.get<{ data: any }>(this.basePath + this.checkPaymentReferenceUrl + "?processLink=" + processLink, { params })
			.toPromise()
			.then(
				res => res,
				err => err.error
			)
			.catch(e => e.error);
	}

	tsduInterogareReferinta(data: any, processLink: boolean = false) {
		let params = new HttpParams();
		params = params.append('referenceNumber', data.reference);
		return this.http.get<{ data: any }>(this.basePath + this.tsduInterogareReferintaUrl + "?processLink=" + processLink, { params })
			.toPromise()
			.then(
				res => res,
				err => err.error
			)
			.catch(e => e.error);
	}

}
